import React, { useCallback, useState } from "react";
import { Button } from "@mui/material";
import { PageHeader } from "shared/components/Headers/PageHeader";
import { PlusCircleIcon } from "shared/icons/PlusCircleIcon";
import { SupportingInfosTable } from "./SupportingInfosTable";

export const SupportingInfos = () => {
  const [isAddingSupportingInfo, setIsAddingSupportingInfo] = useState<boolean>(false);

  const handleOnCloseForm = useCallback(() => setIsAddingSupportingInfo(false), []);

  return (
    <div className="layout-title-body-page">
      <PageHeader
        pageName="supportingInfos"
        title="Supporting information"
        actions={
          <Button onClick={() => setIsAddingSupportingInfo(true)}>
            <PlusCircleIcon />
            Add supporting information
          </Button>
        }
      />

      <SupportingInfosTable
        isAddingSupportingInfo={isAddingSupportingInfo}
        onClose={handleOnCloseForm}
      />
    </div>
  );
};
